import { render, staticRenderFns } from "./SuppliesHeader.vue?vue&type=template&id=85589ffc&"
import script from "./SuppliesHeader.vue?vue&type=script&lang=ts&"
export * from "./SuppliesHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports